import { useState, useEffect, useCallback } from "react";
import { useAdminData } from "../context/AdminDataContext";
import StatusBadge from "../components/StatusBadge";
import TablePagination from "../components/TablePagination";
import * as XLSX from "xlsx";
import { memberApi } from "../api";
const inputCls =
  "w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#005457]/20 focus:border-[#005457] transition-all";

const MembersManager = () => {
  const [members, setMembers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);

  // if (loading)
  //   return (
  //     <div className="py-20 text-center text-gray-400 text-sm">Loading...</div>
  //   );

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [b] = await Promise.all([memberApi.getAll()]);
      debugger;
      setMembers(Array.isArray(b) ? b : []);

      setFiltered(Array.isArray(b) ? b : []);
    } catch (err) {
      console.warn("API fetch failed:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const exportToExcel = () => {
    const exportData = members.map((member) => ({
      Name: member.name,
      Email: member.email,
      Phone: member.phone,
      Date: formatDate(member.created_at),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

    XLSX.writeFile(
      workbook,
      `members_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };
  useEffect(() => {
    fetchAll();
  }, []);

  return (
    <div className="hobmembers-page">
      <div className="hobmembers-header">
        <div>
          <h2 className="hobmembers-title">Members</h2>
          <p className="hobmembers-count">{members.length} total members</p>
          <button onClick={exportToExcel} className="export-btn">
            Export to Excel
          </button>
        </div>
      </div>

      {/* <div className="hobmembers-filter">
        <input
          type="text"
          placeholder="Search members..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          className="hobmembers-search"
        />
      </div> */}

      <div className="hobmembers-card">
        {filtered.length === 0 ? (
          <div className="hobmembers-empty">No members found.</div>
        ) : (
          <div className="hobmembers-table-wrap">
            <table className="hobmembers-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((member) => (
                  <tr key={member.id}>
                    <td>{member.name}</td>
                    <td>{member.email}</td>
                    <td>{member.phone}</td>
                    <td>{formatDate(member.created_at) || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <TablePagination
              total={filtered.length}
              page={page}
              pageSize={pageSize}
              onPage={setPage}
              onPageSize={setPageSize}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MembersManager;

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
